module.exports = __webpack_public_path__ + "static/simple-medium-hoop-earrings-b5bab4f7e00088980ecce5b8fc7765c9.jpg";